function verificaPrivilegio(itemVerificar, sistema = 2) {

    var context = JSON.parse(localStorage.getItem("context"));


    if (context == null)
        return false;

    var privilegios = context.usuario.privilegios;

    if (!privilegios || privilegios.length == 0)
        return false;


    var possui = false;
    privilegios.forEach(privilegio => {

        if (privilegio == ('SISTEMA_' + sistema + '_ROLE_' + itemVerificar))
            possui = true;

    });

    return possui;


}

export default verificaPrivilegio;